module.exports = __webpack_public_path__ + "90b02edf6aea6a10b7171028559ae663.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/trash-hover.png
// module id = 225
// module chunks = 0